import _Guide from './Guide';

import './style/index.js';

export type { GuideProps, GuideCrossProps, TdGuideStepProps } from './Guide';
export * from './type';

export const Guide = _Guide;
export default Guide;
